const pad2 = (n: number) => String(n).padStart(2, '0');

/** Today's calendar date on the user's clock ("YYYY-MM-DD") — `toISOString()` gives the UTC day, which is a day off near midnight. */
export const todayYmd = (d: Date = new Date()): string => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
